import React from "react";

export default function ErrorModal({ isError, setIsError }) {
  return (
    <div
      className={`fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white w-fit max-w-[340px] z-50 bg-[#FF3737] border-2 rounded-lg py-4 duration-500 ${
        !isError ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
    >
      <div className="flex flex-col items-center p-4">
        <h2 className="font-bold text-xl text-center">An Error Occurred.</h2>
        <p className="text-xs mt-2">Please try again in a few seconds.</p>
        <button
          onClick={() => setIsError(false)}
          className="bg-white rounded-full px-8 py-2 text-xs font-bold text-black mt-8"
        >
          Close
        </button>
      </div>
    </div>
  );
}
